export const DataEmpty: React.FC = () => {
  return (
    <div className='flex flex-col items-center m-auto mt-28'>
      <img className='mb-[10px]' src='/images/empty.png' alt='' />
      <p>データがありません</p>
    </div>
  );
};
